// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"LoginCheckbox_checkbox__3iWFC"};